import { Button } from '@/components/ui/button'
import { User } from 'lucide-react'

export function BookingProfessionalSelection({ flow }: { flow: any }) {
  const washers = flow.collaboratorsQuery.data ?? []

  const handleSelect = (id: string) => {
    flow.setWasherId(id)
  }

  return (
    <div className="space-y-4 animate-in fade-in slide-in-from-bottom-4">
      <h2 className="text-lg font-semibold">Tem preferência de Lavador?</h2>
      
      <div className="grid grid-cols-2 gap-3">
        <button
          onClick={() => handleSelect('')}
          className={`text-center p-4 rounded-xl border transition-all duration-300 flex flex-col items-center justify-center gap-2 ${
            flow.washerId === '' 
              ? 'border-blue-500 bg-blue-500/10' 
              : 'border-slate-800 hover:border-slate-700 bg-slate-800/50'
          }`}
        >
          <div className={`w-12 h-12 rounded-full flex items-center justify-center ${flow.washerId === '' ? 'bg-blue-500/20 text-blue-500' : 'bg-slate-700 text-slate-400'}`}>
            <User className="w-6 h-6" />
          </div>
          <div className="font-semibold text-sm text-slate-100">Sem preferência</div>
          <div className="text-xs text-slate-400">Qualquer um disponível</div>
        </button>

        {washers.map((w: any) => {
          const isSelected = flow.washerId === w.id
          return (
            <button
              key={w.id}
              onClick={() => handleSelect(w.id)}
              className={`text-center p-4 rounded-xl border transition-all duration-300 flex flex-col items-center justify-center gap-2 ${
                isSelected 
                  ? 'border-blue-500 bg-blue-500/10' 
                  : 'border-slate-800 hover:border-slate-700 bg-slate-800/50'
              }`}
            >
              <div className={`w-12 h-12 rounded-full overflow-hidden flex items-center justify-center ${isSelected ? 'ring-2 ring-blue-500' : 'bg-slate-700'}`}>
                <User className={`w-6 h-6 ${isSelected ? 'text-blue-500' : 'text-slate-400'}`} />
              </div>
              <div className="font-semibold text-sm text-slate-100">{w.name}</div>
              <div className="text-xs text-slate-400">{w.role || 'Lavador'}</div>
            </button>
          )
        })}
      </div>

      <div className="pt-4 flex gap-2">
        <Button variant="outline" className="w-full" onClick={() => flow.setStep(2)}>
          Voltar
        </Button>
        <Button className="w-full" onClick={() => flow.setStep(4)}>
          Avançar
        </Button>
      </div>
    </div>
  )
}
